import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@material-ui/core';
import Text from 'components/base/Text';
import { getColor } from 'common/constants/_colors';
import { Flex, Padding } from 'components/base/layout-components';
import {
  TitleSection,
  SaveSection,
  EditDashboardSection,
  EditMode
} from './sections';
import {
  ACCOUNT_TYPES_MAP,
  CAN_EDIT_ACCOUNT_TYPES
} from '@linearb/linjs-common';
import ShareMenuButton from 'components/ShareMenuButton';
import withPermissions from 'connected-components/HOC/PermissionsHOC';

const TopBar = styled(Flex)`
  border-bottom: 1px solid ${getColor('botticelli')};
  padding: 0.2px 2rem 1.3rem 2rem;
  ${({ noBorders }) => (noBorders ? 'border: none' : '')};
`;

const Filters = styled(Padding)`
  padding-right: 0.7rem;

  > .MuiInputBase-root {
    height: 2.1rem;
  }
`;

export const PerformanceTopBar = ({
  reportName,
  reportDescription = '',
  articleId,
  additionalText,
  children = [],
  shouldSave = false,
  isOnEditMode = false,
  isEditable = false,
  updateValues = () => {},
  saveChanges = () => {},
  setEditMode = () => {},
  addMetrics,
  deleteDashboard,
  isPublic,
  togglePrivacy,
  isTeamLicense,
  myAccount,
  creatorId,
  isNew,
  isDashboardNameValid,
  validateName,
  shareMenu = {},
  autoCreated = false
}) => {
  const isCreator = myAccount && myAccount.id === creatorId;
  const metricFilters = (
    <Flex items='center' grow='1'>
      {children &&
        children.map((Child, idx) => <Filters key={idx}>{Child}</Filters>)}
      {additionalText ? (
        <Tooltip title={additionalText}>
          <Text color='shuttleGray' minWidth='6rem' multiLineEllipsisAfter={2}>
            {additionalText}
          </Text>
        </Tooltip>
      ) : null}
    </Flex>
  );

  return (
    <TopBar noBorders={true} justify='space-between' data-cy='report-topBar'>
      <Flex direction='column' width='100%'>
        <Flex items='center' direction='row' mb='small'>
          <TitleSection
            title={reportName}
            description={reportDescription}
            setEditMode={setEditMode}
            isOnEditMode={isOnEditMode}
            articleId={articleId}
            isEditable={isEditable}
            setEditedName={updateValues}
            isDashboardNameValid={isDashboardNameValid}
          />
          {isOnEditMode && metricFilters}
          <Flex>
            {withPermissions({
              WrappedComponent: (
                <Flex data-html2canvas-hide='true' gap='1rem'>
                  {shouldSave && (
                    <SaveSection
                      isNew={isNew}
                      isCreator={isCreator}
                      reportName={reportName}
                      saveChanges={saveChanges}
                      isDashboardNameValid={isDashboardNameValid}
                      validateName={validateName}
                    />
                  )}
                  {shareMenu.isVisible && <ShareMenuButton {...shareMenu} />}
                  {isEditable && !isNew && (
                    <EditDashboardSection
                      autoCreated={autoCreated}
                      setEditMode={setEditMode}
                      isOnEditMode={isOnEditMode}
                      isCreator={isCreator}
                      isAdmin={myAccount.type_id === ACCOUNT_TYPES_MAP.Primary}
                      addMetrics={addMetrics}
                      deleteDashboard={deleteDashboard}
                    />
                  )}
                </Flex>
              ),
              requiredPermissions: CAN_EDIT_ACCOUNT_TYPES
            })}
          </Flex>
        </Flex>
        {!isOnEditMode && metricFilters}
        {isOnEditMode && (
          <EditMode
            reportDescription={reportDescription}
            updateValues={updateValues}
            isTeamLicense={isTeamLicense}
            isPublic={isPublic}
            togglePrivacy={togglePrivacy}
            isDashboardNameValid={isDashboardNameValid}
          />
        )}
      </Flex>
    </TopBar>
  );
};
